// extracted by mini-css-extract-plugin
export var card = "_92-0";
export var failedIcon = "_92-4";
export var failedIconBadge = "_92-3";
export var icon = "_92-1";
export var successIcon = "_92-2";